import { Platform, View } from "react-native";
import React, { memo } from "react";
import dimensions from "../../../../../globalStyles/dimensions";
import { Colors } from "../../../../../globalStyles/ColorConfig";
import CustomComponent from "../../../../../components/CustomComponent";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import { formatDate } from "../../../../../utils/experienceUtils";

const DateSelect = ({
  item,
  onPress,
  handleDateSelect,
  price,
}: {
  item: any;
  onPress: any;
  handleDateSelect: any;
  price: any;
}) => {
  const timeString = `${item.startTime} - ${item.endTime}`;

  const handlePress = () => {
    handleDateSelect(item.dayString); // Call handleDateSelect first
    onPress(); // Then call onPress
  };

  const shadowStyle =
    Platform.OS === "ios"
      ? {
          shadowColor: Colors.black100,
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.3,
          shadowRadius: 4,
        }
      : Platform.OS === "android"
      ? {
          elevation: 2,
        }
      : {
          shadowColor: "#000",
          shadowOffset: {
            width: 0,
            height: 0,
          },
          shadowOpacity: 0.1,
          shadowRadius: 10,
          elevation: 1,
        };

  return (
    <View
      style={{
        paddingHorizontal: 10,
        paddingVertical: 10,
        borderRadius: 8,
        backgroundColor: Colors.white000,
        shadowColor: Colors.black100,
        justifyContent: "space-around",
        ...shadowStyle,
      }}
    >
      <View style={{ gap: 8 }}>
        <View style={{ gap: 6 }}>
          <CustomComponent.TextView
            title={`${formatDate(item.dayString)}`}
            textStyle={[
              GlobalStyles.title2,
              {
                fontFamily: "InterSemiBold",
                color: Colors.black70,
              },
            ]}
          />
          <CustomComponent.TextView
            title={timeString}
            textStyle={[GlobalStyles.captionText,{
              opacity: 0.8,
            }]}
          />
        </View>
        <CustomComponent.TextView
          title={`฿${price}`}
          textStyle={GlobalStyles.title2}
        />
        <CustomComponent.AppBtn
          name="Choose"
          textStyle={[GlobalStyles.bodyText, { color: Colors.white000 }]}
          style={{
            backgroundColor: Colors.green10,
            opacity: item.slots ? 1 : 0.4,
            borderRadius: 50,
            marginTop:10,
            paddingVertical: dimensions.paddingVertical * 0.8
          }}
          onPress={item.slots ? handlePress : undefined}
          disableAnimation={item.slots ? false : true}
        />
      </View>
    </View>
  );
};

export default memo(DateSelect);